const PREVENT_ACKNOWLEDGEMENT_ACTION = {
    type: 'DIRECT_LINE/POST_ACTIVITY',
    meta: { method: 'keyboard' },
    payload: {
        activity: {
            type: 'typing',
            from: { role: 'user' }
        }
    }
};
export const isPreventAcknowledgementAction = (action) => {
    return action === PREVENT_ACKNOWLEDGEMENT_ACTION;
};
export const preventAcknowledgementOfInitialActivitiesMiddleware = ({ dispatch }) => (next) => (action) => {
    if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {
        dispatch(PREVENT_ACKNOWLEDGEMENT_ACTION);
    }
    return next(action);
};
//# sourceMappingURL=preventAcknowledgementOfInitialActivitiesMiddleware.js.map